import React from 'react';
import { useTranslation } from 'react-i18next';
import Overview from 'Components/Overview';
import { RoleService } from 'Services';
import { handleOnClickEvent } from 'Utils';
import EditMerchantOverviewModal from '../EditMerchantOverviewModal';

const genOverview = (merchantRules: MerchantRulesData, t: (s: String) => string) => [
    {
        id: 'status',
        label: t('Merchant Status'),
        data: merchantRules.config?.merchantEnabled ? t('ACTIVE') : t('INACTIVE')
    },
    {
        id: 'rules',
        label: t('Rules'),
        data: merchantRules.rules.length
    },
    {
        id: 'active',
        label: t('Active'),
        data: merchantRules.rules.filter((r) => r.parameters.active).length
    },
    {
        id: 'modified',
        label: t('Modified'),
        data: merchantRules.rules.filter((r) => r.modifiedFlag === 'modified').length
    },
    {
        id: 'overrides',
        label: t('Merchant Overrides'),
        data: merchantRules?.rules?.filter((r) => r.inherit === 'MERCHANT').length
    },
    {
        id: 'name',
        label: t('Merchant Name'),
        data: merchantRules?.config?.merchantName
    },
    {
        id: 'description',
        label: t('Description'),
        data: merchantRules?.config?.merchantDescription
    }
];

type Props = {
    globalThresholdText?: string;
    globalThreshold: number;
    merchantRules: MerchantRulesData;
    templateRepositoryId: number;
    merchantId: string;
};

const MerchantOverview = ({
    globalThresholdText,
    globalThreshold,
    merchantRules,
    templateRepositoryId,
    merchantId
}: Props) => {
    const [modalOpen, setModalOpen] = React.useState(false);
    const { t } = useTranslation();
    const isAllowed = RoleService.hasEditRuleOrBulkUploadAccess;
    const overview = genOverview(merchantRules, t);
    const thresholdConfig = merchantRules.config;
    const threshold = [
        {
            label: t('Merchant-Specific Aggregate Scoring Threshold'),
            data: thresholdConfig?._formatted?.inputDescription
        }
    ];

    return (
        <>
            <Overview
                dataTestId='merchant-overview'
                leftTitle={t('Merchant Overview')}
                leftData={overview}
                rightData={threshold}
                onButtonLinkClick={isAllowed ? handleOnClickEvent(() => setModalOpen(true)) : undefined}
            />
            {isAllowed && (
                <EditMerchantOverviewModal
                    isOpen={modalOpen}
                    merchantRules={merchantRules}
                    templateRepositoryId={templateRepositoryId}
                    merchantId={merchantId}
                    globalThreshold={globalThreshold}
                    globalThresholdText={globalThresholdText}
                    closeModal={() => setModalOpen(false)}
                />
            )}
        </>
    );
};

export default MerchantOverview;
